import React, { useEffect, useState } from "react";
import CreateProperty from "./CreateProperty";
import { useParams } from "react-router-dom";
import axios from "common/configs/axiosConfigs";
import { toast } from "react-toastify";

const EditProperty = () => {
  const { id } = useParams();
  const companyId = JSON.parse(localStorage.getItem("user-auth")).company_id;
  const [property, setProperty] = useState({});
  const getProperty = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getSingleProperty",
        propertyId: id,
        companyId,
      });
      if (data?.success) {
        setProperty(data?.data);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getProperty();
  }, []);
  return <CreateProperty {...{ property }} />;
};

export default EditProperty;
